import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { ErrorService } from '../../../../@core/utils/error.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { Customer } from '../models/customer';
import { CustomerAttributeValue } from '../models/customerAttributeValue';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
    private errorService: ErrorService
  ) {
    // this.basePath = environment.HOLLINGBERY_API_URL;
    this.basePath = environment.PLATFORM_API_URL;


  }

  public getCustomerList(): Observable<Customer[]> {
    return this.httpClient.get<Customer[]>(`${this.basePath}/api/customer`);
  }

  public getUserCustomerList(): Observable<Customer[]> {
    return this.httpClient.get<Customer[]>(`${this.basePath}/api/customer/ForUser`);
  }

  public getCustomer(customerId: number): Observable<Customer> {
    return this.httpClient.get<Customer>(`${this.basePath}/api/customer/${customerId}`);
  }

  public postCustomer(customer: Customer): Observable<Customer> {
    //Pass saveERPFlag hardcoded true from UI.
    return this.httpClient.post<Customer>(`${this.basePath}/api/customer?saveERPFlag=false`, customer);
  }

  public putCustomer(customer: Customer): Observable<Customer> {
    //Pass saveERPFlag hardcoded true from UI.
    return this.httpClient.put<Customer>(`${this.basePath}/api/customer/${customer.id}?saveERPFlag=false`, customer);
  }

  public deleteCustomer(customerId: number, isERPSave: boolean = false): Observable<Customer> {
    return this.httpClient.delete<Customer>(`${this.basePath}/api/customer/${customerId}?saveERPFlag=${isERPSave}`);
  }

  //Get all custom attributes for customers
  getCustomerAttributes(): Observable<CustomerAttributeValue[]> {
    return this.httpClient.get<CustomerAttributeValue[]>(
      `${this.basePath}/api/customerattribute/getall`);
  }
}
